
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/ski-report-reviews",
      function () {
        return require("private-next-pages/[region]/[resort]/ski-report-reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/ski-report-reviews"])
      });
    }
  